export default "__VITE_ASSET__CGgozio1__"